module.exports = __webpack_public_path__ + "static/media/event_staff_emp.cd25dc66.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/job-categories/event_staff_emp.png
// module id = 415
// module chunks = 0